import axios from "axios";
import API_CONFIG from "../../Configurations/ApiDeclaration";

export function LogOutUser(param, token) {
    const URL = API_CONFIG.LOG_OUT_USER + param;
    const headers = {
        headers: { Authorization: `Bearer ${token}` },
    };
    return axios.get(URL, headers);
}